import { postBlob } from "../../httpClients/clients/http.client";
import { downloadBlob } from "../../utils/downloadBlob";
import {
  EpidemiologyExportInput,
  formatEpidemiologyExportRequest,
  formatPrevProjExportRequest,
  PrevProjExportInput,
} from "../../utils/formatExportRequest";
import {
  getEpidemiologyExportFilename,
  getPrevProjExportFilename,
} from "../../utils/normalizeLocCodes";

const BASE_PATH = "/export";

export const ExportApi = {
  exportToZip: async (body: EpidemiologyExportInput, token: string, signal?: AbortSignal) => {
    const request = formatEpidemiologyExportRequest(body);
    const file = await postBlob(`${BASE_PATH}`, request, {
      headers: { Authorization: `Bearer ${token}` },
      signal,
    });
    downloadBlob(file, getEpidemiologyExportFilename(request.locCodes));
  },
};

export const ExportPrevProjApi = {
  exportToZip: async (body: PrevProjExportInput, token: string, signal?: AbortSignal) => {
    const request = formatPrevProjExportRequest(body);
    const file = await postBlob(`${BASE_PATH}/prevProj`, request, {
      headers: { Authorization: `Bearer ${token}` },
      signal,
    });
    downloadBlob(file, getPrevProjExportFilename(request.locCodes));
  },
};
